var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapsLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 21",
    style: {
      enableBackground: "new 0 0 18 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D7D5D5",
    d: "M12.3,21H5.7C4.8,21,4,20.2,4,19.4v-1.7C4,16.8,4.8,16,5.7,16h6.7c0.9,0,1.7,0.8,1.7,1.6v1.7 C14,20.2,13.2,21,12.3,21z M6,19h6v-1H6V19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7D5D5",
    d: "M12.4,15H5.6C4.7,15,4,14.2,4,13.3v-1.7H1.5c-0.6,0-1.1-0.3-1.4-0.9C-0.1,10.2,0,9.6,0.3,9.1l7.4-8.5 C8,0.2,8.5,0,9,0c0.5,0,1,0.2,1.3,0.6l7.3,8.5c0.4,0.5,0.5,1.1,0.2,1.6c-0.3,0.5-0.8,0.9-1.4,0.9H14v1.7C14,14.2,13.3,15,12.4,15z  M6,13H12v-2.4c0-0.6,0.4-1,1-1h2.4L9,2.2L2.5,9.6H5c0.6,0,1,0.4,1,1V13z M9.2,1.9L9.2,1.9C9.2,1.9,9.2,1.9,9.2,1.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsLock);
export default __webpack_public_path__ + "static/media/caps-lock.3d8a3851d567cb581787fa4b86173829.svg";
export { ForwardRef as ReactComponent };